import LifecycleConfirmModal from "../../realty/widgets/LifecycleConfirmModal";

function EditManageModals({
  property,
  onConfirmPublish,
  onConfirmUnpublish,
  onConfirmReserve,
  onConfirmSold,
  onConfirmArchive,
  onConfirmReactivate,
  onConfirmDelete,
  isMutatingStatus,
  isDeleting,
}) {
  const isBusy = Boolean(isMutatingStatus || isDeleting);

  return (
    <div className="modals">
      <LifecycleConfirmModal
        id="content-setting-publish"
        actionId="publish"
        property={property}
        onConfirm={onConfirmPublish}
        isBusy={isBusy}
      />
      <LifecycleConfirmModal
        id="content-setting-unpublish"
        actionId="unpublish"
        property={property}
        onConfirm={onConfirmUnpublish}
        isBusy={isBusy}
        confirmClassName="action-btn action-btn--accent"
      />
      <LifecycleConfirmModal
        id="content-setting-reserve"
        actionId="reserve"
        property={property}
        onConfirm={onConfirmReserve}
        isBusy={isBusy}
      />
      <LifecycleConfirmModal
        id="content-setting-sold-out"
        actionId="sold"
        property={property}
        onConfirm={onConfirmSold}
        isBusy={isBusy}
      />
      <LifecycleConfirmModal
        id="content-setting-archive"
        actionId="archive"
        property={property}
        onConfirm={onConfirmArchive}
        isBusy={isBusy}
        confirmClassName="action-btn action-btn--accent"
      />
      <LifecycleConfirmModal
        id="content-setting-reactivate"
        actionId={property?.status === "reserved" ? "return_active" : "reactivate"}
        property={property}
        onConfirm={onConfirmReactivate}
        isBusy={isBusy}
      />
      <LifecycleConfirmModal
        id="content-setting-delete"
        actionId="delete"
        property={property}
        onConfirm={onConfirmDelete}
        isBusy={isBusy}
        confirmClassName="action-btn action-btn--danger"
      />
    </div>
  );
}

export default EditManageModals;
